import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/SoloPaymentInvoices/helpers'
import soloPaymentInvoicesRepository from '@/repository/generatedRepository/soloPaymentInvoicesRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'

const state = {
  list: [],
  filters: StorageService.get(storageKeys.SOLO_PAYMENT_INVOICES_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, filters) {
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.SOLO_PAYMENT_INVOICES_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })

    const { data } = await soloPaymentInvoicesRepository.list(preparedFilters)

    context.commit('setList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async searchSoloPaymentInvoices(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
    })
    const { data } = await soloPaymentInvoicesRepository.list(preparedFilters)
    return { products: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await soloPaymentInvoicesRepository.get(id)
    return data
  },
  createItem(context, payload) {
    return soloPaymentInvoicesRepository.post(payload)
  },
  loadPreview(context, payload) {
    return soloPaymentInvoicesRepository.preview(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return soloPaymentInvoicesRepository.put(id, data)
  },
  deleteItem(context, payload) {
    return soloPaymentInvoicesRepository.delete(payload)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.SOLO_PAYMENT_INVOICES_FILTERS)
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.SOLO_PAYMENT_INVOICES_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
